export const LOGIN = 'AUTH/LOGIN';
export const LOGOUT = 'AUTH/LOGOUT';
export const SET_PREVIOUS_LOCATION = 'AUTH/SET_PREVIOUS_LOCATION';
export const UNSET_PREVIOUS_LOCATION = 'AUTH/UNSET_PREVIOUS_LOCATION';